<script lang="ts">
  import type { Snippet } from 'svelte'
  import Flyout from '@components/overlays/Flyout.svelte'
  import HeaderMenuButton from './HeaderMenuButton.svelte'
  import type { FlyoutTriggerProps } from '@components/overlays/flyout'
  import { trackElementInteraction } from 'frontend/shared/javascripts/util/analytics'
  import { trackInteraction, type Interaction } from 'frontend/shared/javascripts/tracking'

  let {
    label,
    align = 'center',
    current = false,
    openOnHover = false,
    onIntent,
    tracking,
    trigger,
    children,
  }: {
    label: string
    align?: 'center' | 'right'
    current?: boolean
    openOnHover?: boolean
    onIntent?: () => void
    /** The catalogue entry for this menu. Without it the push keeps its class-list element.id. */
    tracking?: Interaction
    trigger: Snippet
    children: Snippet<[{ close: () => void }]>
  } = $props()

  let triggerElement: HTMLElement | undefined = $state()

  function trackToggle(dropdownExpanded: boolean) {
    if (!triggerElement) return

    if (tracking) {
      trackInteraction(
        'dropdown.toggle',
        { ...tracking, params: { dropdownExpanded } },
        triggerElement,
      )
      return
    }

    trackElementInteraction(triggerElement, 'dropdown.toggle', { dropdownExpanded })
  }
</script>

{#snippet button({ open, props }: FlyoutTriggerProps)}
  <HeaderMenuButton {props} {open} {current}>
    {@render trigger()}
  </HeaderMenuButton>
{/snippet}

<div class="headerMenu">
  <Flyout
    {label}
    {align}
    {openOnHover}
    {onIntent}
    caret
    mobileFullscreen
    trigger={button}
    {children}
    bind:triggerElement
    onOpen={() => trackToggle(true)}
    onClose={() => trackToggle(false)}
  />
</div>

<style>
  .headerMenu {
    --flyout-gap: var(--space-3);
    --flyout-width: max-content;
    --flyout-padding: 0;
    --flyout-overflow: visible;
    --flyout-shadow: var(--box-shadow-1);

    display: flex;
    height: 100%;
  }
</style>
